<template>
  <!-- End Main Header -->
  <el-affix :offset="0">
    <header class="main-header header-style-one">
      <!--        &lt;!&ndash; Header Upper &ndash;&gt;-->
      <div class="header-upper">
        <div class="auto-container">
          <div class="inner-container clearfix">
            <!--Logo-->
            <div class="logo-box clearfix">
              <div class="logo">
                <router-link to="/" class="flex">
                  <img  src="/images/logo_SBIPRO.png" width="78px" height="78px" />
                  <div v-if="URLTYPE == 'sbipro'" class="globalName">
                    GeoJade Middle East SBIPRO FZ-LLC
                  </div>
                </router-link>
              </div>
            </div>
            <!--Nav-->
            <div class="nav-outer clearfix">
              <!--Mobile Navigation Toggler-->
              <div class="mobile-nav-toggler"><span class="icon flaticon-menu-1"></span></div>
              <!-- Main Menu -->
              <nav class="main-menu navbar-expand-md navbar-light">
                <div id="navbarSupportedContent" class="collapse navbar-collapse show clearfix">
                  <ul class="navigation clearfix">
                    <li :class="{ current: isActive('/home') }">
                      <router-link to="/">Home</router-link>
                    </li>
                    <li :class="{ current: isActive('/news') }">
                      <router-link to="/news">News</router-link>
                    </li>
                    <li
                     :class="{
                        current: isActive('/tenders') || isChildRouteActive('/tenders'),
                        dropdown: true,
                      }"
                    >
                      <router-link to="/tenders/biddingInformation"
                        >Tenders</router-link
                      >
                      <ul>
                        <li :class="{ current: isActive('/tenders/biddingInformation') }">
                          <router-link to="/tenders/biddingInformation?name=Bidding Information"
                            >Bidding Information</router-link
                          >
                        </li>
                        <li :class="{ current: isActive('/tenders/historybiddinginformation') }">
                          <router-link
                            to="/tenders/historybiddinginformation?name=History Bidding Information"
                            >History Bidding Information</router-link
                          >
                        </li>
                        <!-- <li  :class="{ current: isActive('/tenders/keyAcquiredItem') }">
                        <router-link
                          to="/tenders/keyAcquiredItem?name=Key Acquired Item"
                          >Key Acquired Item</router-link>
                      </li> -->
                      </ul>
                    </li>
										<li :class="{ current: isActive('/recruitment') }">
                      <router-link to="/recruitment">Recruitment Info</router-link>
                    </li>
                    <!-- <li :class="{ current: isActive('/contactUs') }">
                      <router-link to="/contactUs">Contact US</router-link>
                    </li> -->
                    <li
                      :class="{
                        current: isActive('/aboutUs'),
                      }"
                    >
										<!-- :class="{
                        current: isActive('/aboutUs') || isChildRouteActive('/aboutUs'),
                        dropdown: true,
                      }" -->
                      <router-link to="/aboutUs">About Us</router-link>
                      <!-- <ul>
                        <li :class="{ current: isActive('/aboutUs') }">
                          <router-link to="/aboutUs">About Us</router-link>
                        </li>
                        <li :class="{ current: isActive('/aboutUs/project') }">
                          <router-link to="/aboutUs/project">Oil and gas exploration and development projects</router-link>
                        </li>
                        <li :class="{ current: isActive('/aboutUs/scholarship') }">
                          <router-link to="/aboutUs/scholarship">Scholarship</router-link>
                        </li>
                        <li :class="{ current: isActive('/aboutUs/socialResponsibility') }">
                          <router-link to="/aboutUs/socialResponsibility"
                            >Social Responsibility</router-link
                          >
                        </li>
                        <li :class="{ current: isActive('/aboutUs/hsee') }">
                          <router-link to="/aboutUs/hsee">HSSE Responsibility</router-link>
                        </li>
                      </ul> -->
                    </li>
                    <li v-if="clearBtnShow">
                      <el-link @click="clearPassword" type="warning"
                        >clear the password<el-icon style="margin-left: 5px"><Delete /></el-icon
                      ></el-link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!--End Header Upper-->
      <!-- Mobile Menu  -->
      <div class="mobile-menu">
        <div class="menu-backdrop"></div>
        <div class="close-btn"><span class="icon flaticon-targeting-cross"></span></div>

        <nav class="menu-box">
          <div class="nav-logo">
            <router-link to="/">
              <img src="/images/SBIPRO-02.png" />
            </router-link>
          </div>
          <div class="menu-outer"></div>
        </nav>
      </div>
    </header>
  </el-affix>
</template>

<script>
import router from '@/router/index.js'
export default {
  name: 'Header',
  data() {
    return {
      URLTYPE: this.$store.screen.URLTYPE, //type
      clearBtnShow: '',
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (localStorage.getItem('tender_access_password')) {
          this.clearBtnShow = true
        } else {
          this.clearBtnShow = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (localStorage.getItem('tender_access_password')) {
      this.clearBtnShow = true
    }
  },
  methods: {
    isActive(path, queryValue = null) {
      // 检查路径是否匹配
      if (this.$route.path === path) {
        // 如果有查询参数要求，检查查询参数
        if (queryValue) {
          return this.$route.query.name === queryValue
        }
        return true
      }
      return false
    },
    // 检查子路由是否激活
    isChildRouteActive(parentPath) {
      return this.$route.path.startsWith(parentPath) && this.$route.path !== parentPath
    },
    clearPassword() {
      localStorage.removeItem('tender_access_password')
      this.$message.success('Password cleared successfully')
      this.clearBtnShow = false
      router.push('/home')
    },
  },
}
</script>

<style lang="scss" scoped>
.globalName {
  font-size: 32px;
  font-weight: 700;
  line-height: 78px;
  color: #000;
	margin-left: 10px;
}
.flex{
	    display: flex;
    align-items: center;
}
</style>
